import { useState, type FormEvent } from 'react';
import { Link } from 'react-router';
import { api, errorMessage } from '../../shared/api/client';
import { Alert, Button, Field } from '../../shared/ui/components';
import { AuthLayout } from './AuthLayout';

/** Pedir un enlace para elegir una contraseña nueva. */
export function ForgotPasswordPage() {
  const [sentTo, setSentTo] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function onSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    const email = String(new FormData(event.currentTarget).get('email')).trim();
    if (!email) {
      setError('Escribe el correo de tu cuenta.');
      return;
    }
    setBusy(true);
    setError(null);
    try {
      await api.post('/security/password-resets', { email });
      setSentTo(email);
    } catch (e) {
      setError(errorMessage(e));
    } finally {
      setBusy(false);
    }
  }

  return (
    <AuthLayout
      title="¿Olvidaste tu contraseña?"
      footer={
        <>
          ¿La recordaste? <Link to="/entrar">Iniciar sesión</Link>
        </>
      }
    >
      {sentTo ? (
        <Alert tone="success">
          Si {sentTo} tiene una cuenta en KEORA, te enviamos un enlace para elegir una contraseña nueva. Revisa tu correo (y la carpeta
          de spam). El enlace vence en 1 hora.
        </Alert>
      ) : (
        <>
          <p className="muted">Escribe el correo de tu cuenta y te enviaremos un enlace para elegir una contraseña nueva.</p>
          <form className="form" onSubmit={onSubmit} noValidate>
            {error ? <Alert>{error}</Alert> : null}
            <Field label="Correo" name="email" type="email" autoComplete="email" required />
            <Button type="submit" busy={busy} className="btn--block">
              Enviar enlace
            </Button>
          </form>
        </>
      )}
    </AuthLayout>
  );
}
